export function hasDataKitBeta(member: unknown): boolean {
  return !!(member as { dataKitBeta?: boolean } | null)?.dataKitBeta;
}
